/**
 * Galleribilden på produktkorten hämtas först när muspekaren når kortet.
 *
 * PHP (lw_loop_product_hover_image) skriver ut <img> utan src/srcset — bara
 * data-hover-*. Utan det hämtade webbläsaren alla bilder direkt trots
 * loading="lazy", eftersom korten ligger i eller strax under viewporten.
 *
 * Bunden bara när enheten faktiskt har hover: på touch triggas bilden aldrig,
 * så där laddas ingenting alls.
 */

const SELECTOR = '.loop-product-second-image[data-hover-src]'

function loadHoverImage(img) {
    const src = img.dataset.hoverSrc
    if (!src) return

    // Nolla data-hover-src först. Då matchar bilden inte SELECTOR längre och
    // hämtas bara en gång, även om pekaren far in och ut över kortet.
    delete img.dataset.hoverSrc

    // Fade in när bytesen är på plats — annars poppar bilden fram mitt i
    // opacity-övergången (se .loop-product-second-image i loop-product.css).
    img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true })

    // sizes före srcset: annars väljer webbläsaren kandidat mot standardbredden 100vw.
    if (img.dataset.hoverSizes) {
        img.sizes = img.dataset.hoverSizes
        delete img.dataset.hoverSizes
    }
    if (img.dataset.hoverSrcset) {
        img.srcset = img.dataset.hoverSrcset
        delete img.dataset.hoverSrcset
    }

    img.src = src
}

function handlePointerOver(event) {
    const card = event.target?.closest?.('li.product')
    if (!card) return

    const img = card.querySelector(SELECTOR)
    if (img) loadHoverImage(img)
}

if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    // Delegerat på document: produktkort tillkommer via load more och
    // Relevanssis live-sök, och slipper då varsin lyssnare.
    document.addEventListener('pointerover', handlePointerOver, { passive: true })
}
